// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-area-code {
  min-width: 7rem;
  margin-right: 1.2rem;
}
.phone-area-code .input-text-form-component {
  width: 100%;
  max-width: 8rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/fields/v2/PhoneNumberForm/AreaCode/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,oBAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;AACJ","sourcesContent":[".phone-area-code {\n  min-width: 7rem;\n  margin-right: 1.2rem;\n\n  .input-text-form-component {\n    width: 100%;\n    max-width: 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
